export class CreateOrderDto {
  constructor(
    userId,
    eventName,
    eventDate,
    numberOfAttendees,
    maximumBudget,
    location,
    subTotal,
    orderItems,
    contactPhone
  ) {
    this.userId = userId;
    this.eventName = eventName;
    this.eventDate = eventDate;
    this.numberOfAttendees = numberOfAttendees;
    this.maximumBudget = maximumBudget;
    this.location = location;
    this.subTotal = subTotal;
    this.orderItems = orderItems;
    this.contactPhone = contactPhone;
  }
}
